(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goof-header"]) return;
  try {
    
(() => {
  if (window.goofSnugInitialized) return;
  window.goofSnugInitialized = true;
  const dialog = document.querySelector('[data-cart]');
  if (!dialog) return;
  const strings = JSON.parse(dialog.querySelector('[data-cart-strings]').textContent);
  const root = dialog.dataset.root;
  const comparePrices=JSON.parse(dialog.querySelector('[data-compare-prices]').textContent);
  const comparison=item=>Math.max(Number(comparePrices[item.variant_id])||0,item.original_price)*item.quantity;
  const list = dialog.querySelector('[data-cart-items]');
  const error = dialog.querySelector('[data-cart-error]');
  let busy = false;
  const money = (value, currency = dialog.dataset.currency) => new Intl.NumberFormat(document.documentElement.lang, {style:'currency',currency}).format(value / 100);
  const el = (tag, text, cls) => { const n=document.createElement(tag); if(text !== undefined)n.textContent=text; if(cls)n.className=cls; return n; };
  const render = cart => {
    list.replaceChildren();
    const count=cart.items.filter(i=>i.product_id===9265657610414).reduce((sum,i)=>sum+i.quantity,0);
    dialog.querySelector('[data-bundle-meter]').value=Math.min(count,3);
    dialog.querySelector('[data-bundle-progress]').textContent=count>=3?strings.progress_three:count===2?strings.progress_two:count===1?strings.progress_one:strings.progress_zero;
    document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
    dialog.querySelector('[data-cart-total]').textContent=money(cart.total_price,cart.currency);
    dialog.querySelector('[data-checkout]').disabled=!cart.item_count;
    const savings=dialog.querySelector('[data-cart-savings]');
    const regular=cart.items.reduce((sum,item)=>sum+comparison(item),0);
    const saved=Math.max(0,regular-cart.total_price);
    dialog.querySelector('[data-cart-compare-row]').hidden=!saved;
    dialog.querySelector('[data-cart-compare]').textContent=money(regular,cart.currency);
    savings.hidden=!saved;
    savings.textContent=strings.total_saved.replace('__PERCENT__',String(regular?Math.round(saved/regular*100):0)).replace('__AMOUNT__',money(saved,cart.currency));
    if(!cart.items.length)list.append(el('p',strings.empty));
    cart.items.forEach(item=>{
      const row=el('article',undefined,'gs-cart-item');
      const image=el('img');image.src=item.featured_image?.url||item.image||'';image.alt=item.featured_image?.alt||item.product_title;
      const body=el('div');body.append(el('h3',item.product_title));
      if(item.variant_title)body.append(el('p',item.variant_title));
      if(item.selling_plan_allocation)body.append(el('p',item.selling_plan_allocation.selling_plan.name));
      const price=el('p');if(comparison(item)>item.final_line_price)price.append(el('s',money(comparison(item),cart.currency)));
      price.append(el('strong',money(item.final_line_price,cart.currency)));body.append(price);
      (item.line_level_discount_allocations||[]).forEach(d=>body.append(el('p',d.discount_application.title+' −'+money(d.amount,cart.currency),'gs-saving')));
      const label=el('label',strings.quantity);const quantity=el('input');quantity.type='number';quantity.min='0';quantity.step='1';quantity.value=item.quantity;quantity.dataset.lineKey=item.key;label.append(quantity);body.append(label);
      const remove=el('button',strings.remove,'gs-remove');remove.type='button';remove.dataset.removeKey=item.key;body.append(remove);row.append(image,body);list.append(row);
    });
  };
  const request = async (path, body) => {
    const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{headers:{'Accept':'application/json'}});
    const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||strings.error);return data;
  };
  const open = async () => {if(!dialog.open)dialog.showModal();error.textContent='';list.textContent=strings.loading;try{render(await request('cart.js'));}catch(e){list.textContent='';error.textContent=e.message;dialog.querySelector('[data-checkout]').disabled=true;}};
  document.addEventListener('click',event=>{
    if(event.target.closest('[data-open-cart]'))open();
    if(event.target.closest('[data-close-cart]'))dialog.close();
    const remove=event.target.closest('[data-remove-key]');if(remove)change(remove.dataset.removeKey,0);
  });
  dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right)dialog.close();}});
  const change = async (key, quantity) => {
    if(busy)return;busy=true;error.textContent='';dialog.querySelectorAll('input,button').forEach(n=>{if(!n.hasAttribute('data-close-cart'))n.disabled=true;});
    try{render(await request('cart/change.js',{id:key,quantity}));}catch(e){error.textContent=e.message;try{render(await request('cart.js'));}catch{}}finally{busy=false;dialog.querySelectorAll('input,button').forEach(n=>n.disabled=false);dialog.querySelector('[data-checkout]').disabled=!list.querySelector('[data-line-key]');}
  };
  dialog.addEventListener('change',event=>{if(event.target.matches('[data-line-key]')){const q=Number(event.target.value);if(Number.isInteger(q)&&q>=0)change(event.target.dataset.lineKey,q);}});
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-goof-form]');if(!form)return;event.preventDefault();if(busy)return;
    if(!form.reportValidity())return;busy=true;
    const button=form.querySelector('[type="submit"]');button.disabled=true;const status=form.querySelector('[data-form-status]');status.textContent='';
    try{const data=new FormData(form);await request('cart/add.js',{items:[{id:Number(data.get('id')),quantity:Number(data.get('quantity'))}]});status.textContent=strings.added;await open();}catch(e){status.textContent=e.message;}finally{busy=false;button.disabled=false;}
  });
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-variant-select]'))return;
    const select=event.target;const selected=select.selectedOptions[0];const form=select.closest('form');form.querySelector('[type="submit"]').disabled=selected.dataset.available!=='true';
    document.querySelectorAll('[data-product-price]').forEach(n=>n.textContent=selected.dataset.price);
    const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);
  });
  window.addEventListener('pageshow',()=>{busy=false;document.querySelectorAll('[data-goof-form]').forEach(f=>{const selected=f.querySelector('[data-variant-select]')?.selectedOptions[0];f.querySelector('[type="submit"]').disabled=selected?selected.dataset.available!=='true':f.querySelector('[type="submit"]').dataset.available!=='true';});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goof-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-photo]');if(!button)return;
  const gallery=button.closest('.gs-gallery');const photo=gallery.querySelector('#gs-main-photo');if(!photo)return;
  photo.srcset=[360,540,800,1200].map(width=>button.dataset.photo.replace(/([?&])width=\d+/, '$1width='+width)+' '+width+'w').join(', ');photo.src=button.dataset.photo;photo.alt=button.dataset.alt;
  gallery.querySelectorAll('[data-photo]').forEach(n=>n.setAttribute('aria-pressed',String(n===button)));
});

let goofSwipe=null;
let goofTouch=null;
const moveGoofPhoto=(surface,dx)=>{
  const buttons=Array.from(surface.closest('.gs-gallery').querySelectorAll('[data-photo]'));
  if(buttons.length<2)return;
  const current=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-pressed')==='true'));
  buttons[(current+(dx<0?1:-1)+buttons.length)%buttons.length].click();
};
document.addEventListener('touchstart',event=>{
  goofTouch=null;
  const surface=event.target.closest('.gs-gallery .gs-photo');
  if(!surface||event.touches.length!==1||!window.matchMedia('(max-width:760px)').matches)return;
  if(window.visualViewport&&window.visualViewport.scale>1)return;
  const touch=event.touches[0];
  goofTouch={surface,id:touch.identifier,x:touch.clientX,y:touch.clientY,dx:0,locked:false};
},{passive:true});
document.addEventListener('touchmove',event=>{
  if(!goofTouch)return;
  if(event.touches.length!==1){goofTouch=null;return;}
  const touch=event.touches[0];
  if(touch.identifier!==goofTouch.id)return;
  const dx=touch.clientX-goofTouch.x,dy=touch.clientY-goofTouch.y;
  if(!goofTouch.locked){
    if(Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)*1.8){goofTouch=null;return;}
    if(Math.abs(dx)>=4)goofTouch.locked=true;
  }
  if(event.cancelable)event.preventDefault();
  goofTouch.dx=dx;
},{passive:false});
document.addEventListener('touchend',event=>{
  if(!goofTouch)return;
  const swipe=goofTouch;goofTouch=null;
  const touch=Array.from(event.changedTouches).find(touch=>touch.identifier===swipe.id);
  if(!touch||!swipe.locked)return;
  const dx=touch.clientX-swipe.x;
  if(Math.abs(dx)>=18)moveGoofPhoto(swipe.surface,dx);
},{passive:true});
document.addEventListener('touchcancel',()=>{goofTouch=null;},{passive:true});
document.addEventListener('pointerdown',event=>{
  if(event.pointerType==='touch')return;
  if(!event.isPrimary){goofSwipe=null;return;}
  const surface=event.target.closest('.gs-gallery .gs-photo');
  if(!surface||!window.matchMedia('(max-width:760px)').matches||event.button!==0)return;
  if(window.visualViewport&&window.visualViewport.scale>1)return;
  goofSwipe={surface,id:event.pointerId,x:event.clientX,y:event.clientY};
});
document.addEventListener('pointermove',event=>{
  if(!goofSwipe||event.pointerId!==goofSwipe.id)return;
  const dx=Math.abs(event.clientX-goofSwipe.x),dy=Math.abs(event.clientY-goofSwipe.y);
  if(dy>12&&dy>dx)goofSwipe=null;
});
document.addEventListener('pointercancel',()=>{goofSwipe=null;});
window.addEventListener('blur',()=>{goofSwipe=null;goofTouch=null;});
document.addEventListener('pointerup',event=>{
  if(!goofSwipe||event.pointerId!==goofSwipe.id)return;
  const swipe=goofSwipe;goofSwipe=null;
  const dx=event.clientX-swipe.x,dy=event.clientY-swipe.y;
  if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)*1.5)return;
  const gallery=swipe.surface.closest('.gs-gallery');
  const buttons=Array.from(gallery.querySelectorAll('[data-photo]'));
  if(buttons.length<2)return;
  const current=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-pressed')==='true'));
  buttons[(current+(dx<0?1:-1)+buttons.length)%buttons.length].click();
});
document.addEventListener('dragstart',event=>{
  if(event.target.closest('.gs-gallery .gs-photo')&&window.matchMedia('(max-width:760px)').matches)event.preventDefault();
});

const updateGoofBundlePrices=()=>{
  document.querySelectorAll('.gs-bundles').forEach(bundles=>{
    const form=bundles.closest('form');
    const option=form.querySelector('[data-variant-select]')?.selectedOptions[0];
    const unit=Number(option?.dataset.unitPrice||bundles.dataset.unitPrice);
    const compare=Number(option?.dataset.unitCompare||bundles.dataset.unitCompare);
    const currency=bundles.dataset.currency||'USD';
    const format=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency});
    const money=cents=>format.format(cents/100);
    const selected=Number(form.querySelector('[name="quantity"]:checked')?.value||1);
    bundles.querySelectorAll('[data-bundle]').forEach(card=>{
      const quantity=Number(card.dataset.bundle);
      const total=Math.round(unit*quantity*(quantity===2?.85:quantity===3?.8:1));
      const comparison=compare*quantity;
      const saving=bundles.dataset.saveTemplate.replace('__AMOUNT__',money(Math.max(0,comparison-total))).replace('__PERCENT__',String(comparison>0?Math.round(Math.max(0,comparison-total)/comparison*100):0));
      card.querySelector('[data-bundle-price]').textContent=money(total);
      card.querySelector('[data-bundle-compare]').textContent=money(comparison);
      card.querySelector('[data-bundle-saving]').textContent=saving;
      if(quantity===selected){
        document.querySelectorAll('[data-product-price]').forEach(n=>n.textContent=money(total)+' '+currency);
        document.querySelectorAll('[data-product-compare]').forEach(n=>n.textContent=money(comparison)+' '+currency);
        document.querySelectorAll('[data-product-badge]').forEach(n=>n.textContent=card.querySelector('.gs-saving-badge').textContent);
        document.querySelectorAll('[data-product-saving]').forEach(n=>n.textContent=saving);
      }
    });
  });
};
document.addEventListener('change',event=>{if(event.target.matches('[data-variant-select],.gs-bundles input'))queueMicrotask(updateGoofBundlePrices);});
window.addEventListener('pageshow',updateGoofBundlePrices);
document.addEventListener('shopify:section:load',updateGoofBundlePrices);
updateGoofBundlePrices();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
